function MonthlySummaryReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">MonthlySummaryReport</div>
      </>
    );
  }
  
  export default MonthlySummaryReport;